/**
 * LogsModal — Modal de visualização de logs do ambiente
 */
import { useState, useEffect } from 'preact/hooks';
import { api } from '../../api/client';
import { T } from '../../styles/tokens';
import { Button, Icon } from '../../components/ui';

interface Props {
  envId: string;
  envName: string;
  onClose: () => void;
}

export function LogsModal({ envId, envName, onClose }: Props) {
  const [logs, setLogs] = useState('Carregando...');

  useEffect(() => {
    api.get<any>(`/cloud/workspaces/${envId}/logs`).then(res => {
      setLogs(res.logs || 'Sem logs disponíveis');
    }).catch(err => {
      setLogs(`Erro ao buscar logs: ${err.message}`);
    });
  }, [envId]);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: T.bgOverlay, backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: T.bgModal, borderRadius: 16, padding: 24, width: '90%', maxWidth: 680,
        maxHeight: '80vh', display: 'flex', flexDirection: 'column',
        border: `1px solid ${T.border}`,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: T.text }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <Icon name="terminal" size={16} /> Logs — {envName}
            </span>
          </h3>
          <Button variant="ghost" onClick={onClose} style={{ background: 'none', border: 'none', color: T.textSecondary, cursor: 'pointer', fontSize: 18 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </Button>
        </div>
        <pre style={{
          flex: 1, overflow: 'auto', padding: 16, background: T.bg, borderRadius: 10,
          color: T.success, fontSize: 12, fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
          lineHeight: 1.6, whiteSpace: 'pre-wrap', margin: 0, minHeight: 200,
          border: `1px solid ${T.border}`,
        }}>
          {logs}
        </pre>
      </div>
    </div>
  );
}
